import React from 'react';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, SMS_HREF } from '../lib/contact';
export function Footer() {
  return <footer className="bg-iron py-10" data-id="element-26" data-mp="32nul2myzi10u">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-4 text-center sm:px-6 md:flex-row md:text-left" data-id="element-27" data-mp="32ovxaurqktk5">
        <div data-id="element-28" data-mp="36nd75m2jki59">
          <p className="font-display text-xl text-cream" data-id="element-29" data-mp="3uf0obca04euc">Castle Barrel</p>
          <p className="mt-1 font-stamp text-[10px] uppercase tracking-[0.25em] text-oak-light" data-id="element-30" data-mp="3uftkjjbc3ly8">
            Handmade wine barrel trash cans &middot; Santa Barbara, CA
          </p>
        </div>

        <div className="flex items-center gap-3" data-id="element-31" data-mp="3le2katzkc7br">
          <a href={SMS_HREF} className="inline-flex items-center gap-2 rounded-sm border border-cream/30 px-4 py-2 font-stamp text-xs uppercase tracking-widest text-cream transition-colors hover:border-cream" data-id="element-32" data-mp="3qcx9cdo4is4b">
            <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-33" data-mp="2ezl35w4w5xez" />
            Text
          </a>
          <a href={PHONE_HREF} className="inline-flex items-center gap-2 rounded-sm border border-cream/30 px-4 py-2 font-stamp text-xs uppercase tracking-widest text-cream transition-colors hover:border-cream" data-id="element-34" data-mp="3l9si93m2mqny">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="3q83rpd8gez5n" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
      <p className="mx-auto mt-8 max-w-6xl px-4 text-center font-body text-xs text-cream/40 sm:px-6 md:text-left" data-id="element-36" data-mp="81pfbipu2x9d">
        &copy; {new Date().getFullYear()} Castle Barrel. All rights reserved.
      </p>
    </footer>;
}